import React from "react";
import { Info } from "@material-ui/icons";
import styles from "../styles/Alert.module.scss";

/**
 * Componente de alerta reutilizavel.
 *
 * @param {"warning"} variant - Variante do alerta que define a cor
 * @param {React.ReactNode} children - Conteudo do alerta
 */
export default function Alert({ variant = "warning", children }) {
  return (
    <div className={`${styles.alert} ${styles[variant]}`}>
      <Info className={styles.icone} />
      <p className={styles.texto}>{children}</p>
    </div>
  );
}
